import React from 'react';
import SearchHeader from '../../../NodeGroups/DTOrderSearch/Common/SearchHeader/SearchHeader';
import { ResultsTable } from '../../../NodeGroups/DTOrderSearch/DTOrderSearch.styles';
import {
  ResultsHeaderColumn,
  ResultsHeaderRow,
  Results,
} from '../../../NodeGroups/DTOrderSearch/Common/SearchResults/Common/SearchResultsLayout/SearchResultsLayout.styles';
import { StoreSearchResultsList } from '../StoreSearchResultsList/StoreSearchResultsList';

export const StoreSearchResults = (props) => {
  const { stores } = props;

  return (
    <Results>
      <SearchHeader />
      <ResultsTable>
        <ResultsHeaderRow>Select a store location</ResultsHeaderRow>
        <ResultsHeaderRow>
          <ResultsHeaderColumn>STREET ADDRESS</ResultsHeaderColumn>
          <ResultsHeaderColumn>CITY</ResultsHeaderColumn>
          <ResultsHeaderColumn>STATE</ResultsHeaderColumn>
          <ResultsHeaderColumn>ZIP CODE</ResultsHeaderColumn>
        </ResultsHeaderRow>
        <StoreSearchResultsList stores={stores} />
      </ResultsTable>
    </Results>
  );
};
